<template>
  <div class="admin-table">
    <div class="box">
      <slot name="box-upper"></slot>
      <div class="box-wrapper">
        <div class="flex space-between" style="padding-bottom:20px" v-if="pagination">
          <div class="flex align-center">
            <span>검색결과 {{ filteredCount }} 개</span>
            <!--
             <span style="color:#ccc"> / </span> 전체</span><span> {{ allCount }}</span><span>개</span>
            -->
          </div>
          <div class="flex-align">
            <div class="flex-align" style="margin-right:8px">
              <toggle-button @change="e=>enableDragScroll = e.value"
                             :value="enableDragScroll"
                             :sync="true"
                             class="changed-font"
                             :width="50"
                             :height="24"></toggle-button>
              <span style="margin-left:4px">좌우로 스와이프</span>
              <i class="material-icons" style="font-size:17px;margin-left:2px">open_with</i>
            </div>
            <!-- 10개씩보기 -->
            <div class="control">
            <span class="select">
              <select v-model="page_length" @change="selPageLength">
                <option v-for="(it,idx) in pageLengthList" :key="'list-'+idx"
                        :value="it.value">{{ it.label }}</option>
              </select>
            </span>
            </div>
          </div>
        </div>
        <scroll-table-wrapper :enableDragScroll="enableDragScroll">
          <!-- 테이블 -->
          <table class="table admin-table" style="table-layout: fixed">
            <thead>
            <tr>
              <th v-for="(field, idx) in field_list" :key="'field-'+idx" :style="'width:'+field.width">
                <lp-ordering
                  :data="field"
                  :update_field="update_field"
                  @onSelect="selectOrdering"
                  v-if="enableOrdering(field.eng_name)">
                    <span style="display:inline-block"
                          v-if="field.eng_name!=='checkspot'">{{ field.ko_name }}</span>
                </lp-ordering>
                <div v-else-if="field.eng_name==='checkspot'">
                  <lp-check-bool :checked-val="check" @onCheck="clickCheckBox"></lp-check-bool>
                </div>
              </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(item, trIdx) in items" :key="`trIdx-${trIdx}`">
              <td v-for="(field, idx) in field_list" :key="`tdIdx-${idx}`" :style="tdStyle(field)">
                <!--<div v-if="field.eng_name==='index'">{{ trIdx + 1 }}</div>-->
                <slot :name="field.eng_name" :item="item" :idx="trIdx"></slot>

                <!-- 이미지일때 -->
                <div style="text-align: center;display: inline-block"
                     :style="imgField(item[field.eng_name])" @click="clickImg(item[field.eng_name])"
                     v-if="field.eng_name==='img' && item[field.eng_name]"></div>

                <!-- 이미지 array일때 -->
                <template v-if="field.eng_name==='imgs'">
                  <template v-for="(img,idx) in item[field.eng_name].slice(0,1)">
                    <div v-if="isImage(img)" :key="'imgs-item-'+idx"
                         style="text-align: center;display: inline-block"
                         :style="imgField(img)"  @click="clickImg(img)"></div>
                    <div v-else :key="'imgs-item-'+idx" style="margin:4px 0">
                      <a :href="img" target="_blank">
                        <i class="material-icons" style="font-size:16px;vertical-align: middle;color:#999">attach_file</i>파일 {{ idx+1 }}
                      </a>
                    </div>
                  </template>
                </template>

                <!-- 그 외 다른 네임을 가지고 있을 때 -->
                <span v-if="$scopedSlots[field.eng_name] === undefined &&
                        field.eng_name!=='img' && field.eng_name!=='imgs'">{{getName(item,field.eng_name)}}</span>

              </td>
            </tr>
            </tbody>
          </table>
        </scroll-table-wrapper>

        <!-- 선택승인, 선택 미승인 같은 post요청을 하는 경우 -->
        <div>
          <slot name="spot"></slot>
        </div>

        <!-- 페이지 -->
        <div class="pagination-group" v-if="pagination">
          <div class="pagination-btn-prev" @click="startPage">
            <i class="material-icons unselect" style="margin-top:5px;margin-right:-18px">keyboard_arrow_left</i>
            <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_left</i>
          </div>
          <div class="pagination-btn-prev" @click="prevPage">
            <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_left</i>
          </div>
          <div class="pagination-num" v-for="(n,idx) in calcPageList" :key="'page-'+idx">
            <span
              class="unselect"
              :class="{
                'pagination-num-selected': n === filtered.page_num,
                'pagination-num-not-selected': n !== filtered.page_num,
              }"
              @click="changePage(n)"
              style="font-size:1.2rem">{{ n }}</span>
          </div>
          <div class="pagination-btn-next" @click="nextPage">
            <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_right</i>
          </div>
          <div class="pagination-btn-next" @click="endPage">
            <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_right</i>
            <i class="material-icons unselect" style="margin-top:5px;margin-left:-18px">keyboard_arrow_right</i>
          </div>
        </div>
        <sweet-modal ref="imgModal" overlay-theme="dark">
          <div style="text-align:center;overflow-y: auto;max-height:80vh">
            <img :src="selectedImg" style="width:100%">
          </div>
        </sweet-modal>
      </div>
    </div>
    </div>
</template>

<script>
  import LpOrdering from "../common/LpOrdering";
  import pageLengthStructure from './pageLengthStructure'
  import LpCheckBool from "../common/LpCheckBool";
  import {SweetModal} from 'sweet-modal-vue'
  import ScrollTableWrapper from "../common/ScrollTableWrapper";

  export default {
    /*
    * nextPageName : 수정페이지로 랜딩시 필요없음, 단 board/1/post 와 같은 경우에만 사용 (게시판사용중이었으나 현재 사용x)
    * filtered: { page_num:1, page_length:10 ... }
    * filed_list: [ { eng_name: id, ko_name: 번호, width: 65px }, {}, {} ...  ]
    * items: 디비에서 가져온 테이블 구성할 데이터 [{ id:9, name:'김준호', email:'asda@sad.com' }]
    * tabble_width는 min-width값을 주기 위함
    *
    * */
    props:['field_list', 'items', 'filtered', 'table_width',
      'title', 'filteredCount', 'allCount', 'nextPageName', 'enablePagination'],
    components: {
      ScrollTableWrapper,
      LpCheckBool,
      LpOrdering,
      SweetModal
    },
    data(){
      return {
        /*fields:['id','created_time'],
        items:[{'id':1, 'created_time': '2012-03-24'}]*/
        pageLengthList: pageLengthStructure.common,
        page_length:10,
        pagination: true,
        block: 1,
        start: 1,
        end: 1,
        check: false,
        selectedImg: '',
        update_field: '',
        enableDragScroll: false
      }
    },
    computed: {
      tableStyle(){
        if(this.table_width){
          return 'min-width:' + this.table_width + 'px';
        }
        else {
          return 'min-width: 1400px';
        }
      },
      calcPageList() {
        let page_list = [];
        for(let i=this.start; i<=this.end; i++) {
          page_list.push(i);
        }
        return page_list;
      }
    },
    watch: {
      /*totalPage(n) {
        console.log('totalPage', n);
        if(this.start + 10 >= n) {
          this.end = n;
        }
      },*/
      filtered: {
        handler(val) {
          // console.log('end', this.filtered.total_page);
          if(this.filtered.page_num===1) {
            this.start = 1;
            this.block = 1;
          }
          if(this.start + 9 >= this.filtered.total_page) {
            this.end = this.filtered.total_page;
          }
          else if(this.block===1) {
            this.end = 10;
          }
        },
        deep: true
      },
      'filtered.total_page'(n) {
        //console.log(n)
        // if(this.filtered.total_page<10) this.end = this.filtered.total_page;
        if(this.start + 9 >= this.filtered.total_page) {
          this.end = this.filtered.total_page;
        }
      }
    },
    created() {
      if(this.enablePagination!==undefined) this.pagination = this.enablePagination;
    },
    methods:{
      selectOrdering(res) {
        let ordering = res;
        this.update_field = res;
        if(res==='index') {
          ordering = 'id';
        }
        else if(res==='-index') {
          ordering = '-id';
        }
        this.$emit('ordering', ordering);
      },
      clickImg(img) {
        this.selectedImg = img;
        this.$refs.imgModal.open();
      },
      clickCheckBox() {
        this.check=!this.check
        this.$emit('check', this.check);
      },
      visiblePageNumber(n) {
        return n;
      },
      /*// 페이지 숫자 보임여부
      visiblePageNumber(n) {
        // 현재 선택된 페이지 + 9까지 보임
        if(this.filtered.page_num <= n && n <= this.filtered.page_num+9) return true;
        // 전체페이지 - 현재 페이지
        let cal_page = this.filtered.total_page - this.filtered.page_num
        if(cal_page < 5 && n >= this.filtered.total_page - 5) {
          return true
        }
        else return false;
      },*/
      // 내용이 긴 경우에 ellipsis 처리하고 싶은 경우 nameArr에 structure.js에 필드의 영문네임을 배열에 추가해주면 됩니다.
      tdStyle(field){
        let width = 'width:'+field.width+';';
        let ellipsis = 'white-space:nowrap; overflow:hidden; text-overflow: ellipsis;';

        let nameArr = ['content', 'comment', 'answer', 'question', 'answer_content', 'question_content', 'order_content', 'counsel_content', 'choice_items'];
        for(let i=0; i<nameArr.length; i++){
          if(field.eng_name===nameArr[i]){
            return width + ellipsis;
          }
        }
        return '';
      },
      selPageLength(){
        this.$emit('selPageLength',this.page_length);
      },
      changePage(num) {
        this.filtered.page_num = num;
        this.filtered.cur_page = num;
        this.check = false;
        this.$emit('getData');
      },
      prevPage() {
        if (this.filtered.page_num - 10 >= 1) {
          this.block -= 1;
          this.start = (this.block-1)*10+1;
          this.end = this.start + 9;
          this.filtered.page_num = this.start;
          this.filtered.cur_page = this.start;
          this.$emit('getData');
        }
      },
      nextPage() {
        if (this.filtered.page_num + 10 <= this.filtered.total_page) {
          this.block += 1;
          this.start = (this.block-1)*10+1;
          if(this.start + 9 >= this.filtered.total_page) {
            this.end = this.filtered.total_page;
          }
          else {
            this.end = this.start + 9;
          }
          this.filtered.page_num = this.start;
          this.filtered.cur_page = this.start;
          this.$emit('getData');
        }
        else {
          let next_block = this.block+1;
          if ((next_block - 1) * 10 + 1 <= this.filtered.total_page) {
            this.block += 1;
            this.start = (this.block - 1) * 10 + 1;
            this.end = this.filtered.total_page;
            this.filtered.page_num = this.start;
            this.filtered.cur_page = this.start;
            this.$emit('getData');
          }
        }
      },
      startPage() {
        this.block = 1;
        this.start = (this.block-1)*10+1;
        if (this.filtered.total_page>10) this.end = this.start + 9;
        else this.end = this.filtered.total_page;
        this.filtered.page_num = 1;
        this.filtered.cur_page = 1;
        this.$emit('getData');
      },
      endPage() {
        let block = Math.floor(this.filtered.total_page/10);
        let remainder = this.filtered.total_page % 10;
        if(remainder > 0) block += 1;
        this.block = block;
        this.start = (this.block-1)*10+1;
        this.end = this.filtered.total_page;
        this.filtered.page_num = this.filtered.total_page;
        this.filtered.cur_page = this.filtered.total_page;
        this.$emit('getData');
      },
      isImage(img) {
        let result = false;
        ['.jpg', '.jpeg', '.png', '.JPEG', '.JPG', '.PNG', '.gif', '.GIF', '.bmp', '.BMP'].forEach(ext => {
          if(img.indexOf(ext)>-1) {
            result = true;
          }
        });
        return result;
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
      // exhibition일때 ordering 예외처리
      enableOrdering(name){
        if(name==='exhibition' || name==='purchase' || name==='checkspot'){
          return false;
        }
          // 커머스 일때 오더링 숨김
        /*else if(this.$route.path.search('commerce')>-1){
          return false;
        }*/
        else return true;
      },
      getName(item, name) {

        if(name.indexOf('.')>-1) {
          // console.log(item, name)
          let text = name.split('.');
          let value = item[text[0]][name.substr(text[0].length+1, 100)];
          return value;

        }
        else {
          return item[name]
        }
        /*   let value = item;
        name.split('.').forEach( item => {
          value = value[item];
        });

        return value;*/
      }
    }
  }
</script>

<style lang="scss" scoped>
  .admin-table {
    .box {
      padding: 0;
    }
    .box-wrapper {
      padding: 1.25rem;
    }

    .table td, .table th {
      vertical-align: middle;
    }

    .pagination-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
    }

    .pagination-btn-prev
    .pagination-btn-next {
      display: inline-block;
      height: 25px;
    }

    .pagination-num {
      display: inline-block;
    }

    .pagination-btn-prev i
    .pagination-btn-next i {
      color: #18a4ed;
      margin: 4px;
      cursor: pointer;
    }

    .pagination-num {
      padding: 5px 8px;
      cursor: pointer;
      font-size: .9rem;
    }

    .pagination-num-selected {
      color: #18a4ed;
    }

    .pagination-num-not-selected {
      color: #666;
    }

    // 테이블 상태 관련 버튼
    .state-btn {
      width: 100px;
    }

    .ests-btn-confirm-new {     // 신규요청확인
      background-color: #ffb100;
      color: #fff;
      cursor: pointer;
      border: none;
    }

    .ests-btn-request-sheet {     // 견적서 의뢰
      color: #fff;
      background-color: #5cb85c;
      cursor: pointer;
      border: none;
    }

    .ests-btn-write-sheet {    // 견적서 작성
      background-color: #008fd9;
      color: #fff;
      cursor: pointer;
      border: none;
    }

    .ests-btn-accept-order {    // 주문 승인
      background-color: #ffb100;
      color: #fff;
      cursor: pointer;
      border: none;
    }

    .ests-btn-deny-order {    // 주문 거절
      background-color: #db2828;
      color: #fff;
      cursor: pointer;
      border: none;
    }

    .btn-make-comment {    // 상품후기 답변 달기
      background-color: #ebab39;
      color: #fff;
      cursor: pointer;
      border: none;
    }

    .btn-edit-comment {    // 상품후기 답변 수정
      background-color: #064160;
      color: #fff;
      cursor: pointer;
      border: none;
    }

    .admin-table td > div {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3; /* 라인수 */
      -webkit-box-orient: vertical;
      word-wrap:break-word;
      line-height: 1.2em;
    }
    .admin-table td > span {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3; /* 라인수 */
      -webkit-box-orient: vertical;
      word-wrap:break-word;
      line-height: 1.2em;
    }
    a:hover {
      color: #ff5722 !important;
    }
    a:hover i {
      color: #ff5722 !important;
    }
  }
</style>
